import {ezprOrange} from '../_helpers';
import {EZPRTheme} from '../_theme';
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    ThemeProvider,
    FormControl,
    Select,
    MenuItem,
    ListItemText,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LoadingButton from '@mui/lab/LoadingButton';
import {NON_PSL_JUSTIFICATIONS} from '../../utils/constants';

/**
 * This is the popup to select a new justification reason for non psl PR's
 * @param {SelectNonPSLJustificationPopup.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export default function SelectNonPSLJustificationPopup(props) {
    const [selectedJustifications, setSelectedJustifications] = useState([]);
    const [comments, setComments] = useState('');
    useEffect(()=>{
        if (props.nonPslJustification) {
            const reasonMatch = props.nonPslJustification.match(/Reason:(.*?)(Comments:|$)/);
            const commentsMatch = props.nonPslJustification.match(/Comments:(.*)$/);

            const reason = reasonMatch ? reasonMatch[1].trim() : '';
            const comments = commentsMatch ? commentsMatch[1].trim() : '';

            const justifications = reason
                .slice(0, -1) // Remove trailing character if necessary, normally there is a . at the end
                .split(',')
                .map((item) => item.trim());

            setSelectedJustifications(justifications);
            setComments(comments);
        }
    }, [props.nonPslJustification]);

    const handleJustificationChanges = (event) => {
        setSelectedJustifications(event.target.value);
    };

    const handleCommentChange = (event) => {
        setComments(event.target.value);
    };

    const handleChange = () => {
        const parsedComments = comments && comments.length > 0 ? 'Comments: '+ comments : '';
        const nonPslJustificationComment = NON_PSL_JUSTIFICATIONS.includes(selectedJustifications)? 'Non-PSL Justification: Reason: ' + selectedJustifications + '. ' + parsedComments : '';
        props.setNonPslJustification(nonPslJustificationComment);
        props.handleOnClose();
    };

    return (
        <ThemeProvider theme={EZPRTheme}>
            <Dialog open={true} onClose={props.handleOnClose} fullWidth={true}>
                <div className={'pr-popup-header'}>
                    <DialogTitle>Non-PSL Justification</DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={props.handleOnClose}
                        sx={{
                            color: ezprOrange,
                        }}
                    >
                        <CloseIcon
                            sx={{
                                width: '50px',
                                height: '50px',
                            }}
                        />
                    </IconButton>
                </div>
                <DialogContent>
                    <div className='popup-dyn-justification'>
                        <div>Reason why: *</div>
                        <FormControl fullWidth>
                            <Select
                                labelId="justifications-multiple-checkbox-label"
                                id="justifications-multiple-checkbox"
                                value={selectedJustifications}
                                onChange={handleJustificationChanges}
                                displayEmpty
                                size="small"
                                renderValue={(selected) => {
                                    if (selected.length === 0) {
                                        return <span style={{color: 'rgba(0, 0, 0, 0.4)'}}>Please select an option</span>;
                                    }
                                    return selected;
                                }}
                            >
                                {NON_PSL_JUSTIFICATIONS.map((name) => (
                                    <MenuItem key={name} value={name}>
                                        <ListItemText primary={name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <div>Comments:</div>
                        <TextField
                            size={'small'}
                            value={comments}
                            placeholder='Add more comments why you chose a different Supplier than what is suggested to you in the PSL'
                            onChange={handleCommentChange}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        sx={{
                            'color': '#fff',
                            'backgroundColor': ezprOrange,
                            '&:hover': {backgroundColor: '#F2ae49'},
                            ':disabled': {backgroundColor: 'rgba(0,0,0,0.26)'},
                        }}
                        variant={'outlined'}
                        onClick={handleChange}
                        disabled={selectedJustifications.length === 0}
                    >
                        <span>Upload</span>
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
}

SelectNonPSLJustificationPopup.propTypes = {
    nonPslJustification: PropTypes.string,
    setNonPslJustification: PropTypes.func,
    handleOnClose: PropTypes.func,
};
